import React from "react";

// Uses the actual MoonGlow Screens logo image from /public/brand/moonglow-logo.png
// Responsive sizing — pass any of size (px), or use className for tailwind sizes.
export default function Logo({ size = 48, className = "" }) {
  const style = size ? { height: size, width: "auto" } : {};
  return (
    <img
      src="/brand/moonglow-logo.png"
      alt="MoonGlow Screens"
      data-testid="mg-logo"
      style={style}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
}
